import React from "react";
import { aybCategoryService } from "../jwt/_services/ayb/aybCategoryService";

export const aybCategoryProvider = {
    getOptions,
    getItem
};

async function getOptions(customFilter) {
    try {
        const listItems = await aybCategoryService.getOptions( customFilter );
        listItems.data.sort((a, b) => a.titleEsEn.localeCompare(b.titleEsEn));
        return listItems.data.map((itemData) => {
            return (
                {
                    id: itemData.id,
                    value: itemData.titleEsEn,
                    label: <div><label>{itemData.titleEsEn}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message);
    }
}


async function getItem(id) {
    try {
        const item = await aybCategoryService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message);
    }
}